import * as React from 'react';
import { GapSizeType } from '../../../../theme/type/gap-type';
import { TextVariantType } from '../../../../theme/type/text-type';
import { cn, textVariantClass } from '../../../../utils/tailwind';

const paddingClass: Record<GapSizeType, string> = {
    none: 'p-0',
    xxsmall: 'p-xxsmall',
    xsmall: 'p-xsmall',
    vsmall: 'p-vsmall',
    small: 'p-small',
    medium: 'p-medium',
    large: 'p-large',
    vlarge: 'p-vlarge',
    xlarge: 'p-xlarge',
    xxlarge: 'p-xxlarge',
};

interface ValueDescriptionInterface {
    description?: string | React.ReactNode;
    value?: React.ReactNode;
    valueColor?: TextVariantType;
    descriptionColor?: TextVariantType;
    padding?: GapSizeType;
}

export const ValueDescription: React.FC<ValueDescriptionInterface> = ({
    value,
    description,
    valueColor,
    descriptionColor,
    padding,
}) => {
    return (
        <div
            className={cn(
                'z-[99] flex flex-col gap-xsmall w-full text-vlarge leading-vlarge text-neutral-white',
                padding ? paddingClass[padding] : 'p-[3.2rem]',
            )}
        >
            {value && (
                <div
                    className={cn(
                        'text-xxlarge leading-xxlarge font-black',
                        valueColor ? textVariantClass[valueColor] : 'text-text-muted',
                    )}
                >
                    {value}
                </div>
            )}
            {description && (
                <div
                    className={cn(
                        'text-small leading-small',
                        descriptionColor ? textVariantClass[descriptionColor] : 'text-text-muted',
                    )}
                >
                    {description}
                </div>
            )}
        </div>
    );
};
